import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import Login from "./Login";
import Dashboard from "./Dashboard";
import AnalisisCalidadListado from "./AnalisisCalidadListado";
import AnalisisCalidadDetalle from "./AnalisisCalidadDetalle";
import EnvioDocumentosPortalProductorList from "./EnvioDocumentosPortalProductorList";
import ResumenRecepcionesListado from "./ResumenRecepcionesListado"; 
import ProduccionEstimacionListado from "./ProduccionEstimacionListado";
import DashboardHome from "./DashboardHome"; 
import ResumenProcesosListado from "./ResumenProcesosListado";
import ConsolidadoExistenciasListado from "./ConsolidadoExistenciasListado";
import PowerBiAnalisisScreen from "./PowerBiAnalisisScreen";
import VisorCamarasFrio from "./VisorCamarasFrio"; // ⬅️ NUEVO
import InformeAplicaciones from "./InformeAplicaciones";

// Placeholder temporal
const Placeholder = ({ title }) => (
  <div style={{ background:"#fff", padding:16, borderRadius:12 }}>{title} (en construcción)</div>
);

export default function App() {
  return (
    <Routes>
      {/* Público */}
      <Route path="/login" element={<Login />} />

      {/* Protegido con layout */}
      <Route
        path="/dashboard/*"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      >
        <Route index element={<DashboardHome />} />  {/* ⬅️ actualizado */}


        {/* Menú → Aplicaciones */}
        {/* Protegida por el mismo mecanismo legacy que el resto del dashboard
            (PrivateRoute). La autorización real vive en la Edge Function
            informe-aplicaciones, validando el JWT emitido por el login legacy. */}
        <Route path="aplicaciones-fertilizantes" element={<InformeAplicaciones />} />

        {/* Menú → Producción */}
        <Route path="planta/orden-proceso" element={<ResumenProcesosListado />} />
        <Route path="planta/resumen-recepciones" element={<ResumenRecepcionesListado />} /> {/* ⬅️ NUEVO */}


  
        {/* NUEVO → Producción → Estimado de Producción */}
        <Route path="produccion/estimaciones" element={<ProduccionEstimacionListado />} />
        
{/* 👇 NUEVO → Bodega → Consolidado de Existencias */}
        <Route path="bodega/consolidado-existencias" element={<ConsolidadoExistenciasListado />} />


        {/* Análisis de calidad como páginas separadas */}
        <Route path="calidad/analisis" element={<AnalisisCalidadListado />} />
        <Route path="calidad/analisis/:id" element={<AnalisisCalidadDetalle />} />

        {/* Menú → Mantenedores */}
        <Route path="mantenedores" element={<Placeholder title="Mantenedores" />} />

        <Route path="powerbi/analisis-powerbi" element={<PowerBiAnalisisScreen />} />
    <Route path="bodega/camaras-frio" element={<VisorCamarasFrio />} /> 
         {/* Menú → Portal productor */}
        <Route path="portal-productor" element={<EnvioDocumentosPortalProductorList />} /> {/* 👈 aquí */}
      </Route>

      {/* Fallbacks */}
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
